import { boolean, object, optional } from 'superstruct';

export const careDocumentsConfigSchema = object({
  shouldUseDocumentsV2: optional(boolean()),
});
